import React from "react";
import SiteHeader from "./siteHeader";
import Navigation from "./navigation";
import Breadcrumb from "./breadcrumb";
export default function header(props) {
    return (React.createElement("header", null,
        React.createElement(SiteHeader, null),
        React.createElement(Navigation, null),
        React.createElement(Breadcrumb, null)));
}
